module.exports = __webpack_public_path__ + "static/media/19981029_1.8ea0245b.jpg";